import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../core/services/api.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.html',
  styleUrls: ['./companies.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompaniesComponent implements OnInit {
  companies = signal<any[]>([]);
  loading = signal(true);
  error = signal('');

  constructor(private api: ApiService, private router: Router) {}

  ngOnInit() {
    this.api.getCompanies().subscribe({
      next: (data) => { this.companies.set(data); this.loading.set(false); },
      error: () => { this.error.set('Error al cargar empresas'); this.loading.set(false); }
    });
  }

  goToBranches(company: any) {
    this.router.navigate(['/companies', company.idCompany, 'branches']);
  }
}
